import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

import { NetworkPage as Network } from '#src/Network/index.tsx';

const NetworkPage = () => {
  return (
    <RequireAuth>
      <Network />
    </RequireAuth>
  );
};

export default NetworkPage;
